<div id="edge-hole-coordinates-form" cslPerfectScrollbar>
  <table class="simple">
    <thead>
      <tr>
        <th i18n>Отступ от базовой точки</th>
        <th i18n>База</th>
        <th class="delete-col">
          <button i18n-matTooltip mat-icon-button (click)="addCoordAndFocusLast()" matTooltip="[Insert] или [↓]">
            <mat-icon>add</mat-icon>
          </button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of coords; let i = index" class="coord-row">
        <td class="x-col">
          <ng-container *ngIf="side === 'tc' || side === 'bc'; then xTemplate; else yTemplate"></ng-container>
          <ng-template #xTemplate>
            <mat-form-field class="w-full dense-input no-subscript no-label" appearance="outline">
              <input
                type="number"
                required
                [range]="[0, getMaxOffsetByMainAxis]"
                number
                name="edge-hole-x"
                (click)="$any($event.target).select()"
                (ngModelChange)="checkErrors(xField.errors, 'x', i); valueUpdated()"
                matInput
                [(ngModel)]="item.x"
                #xField="ngModel"
                [matTooltipDisabled]="xField.valid"
                [matTooltip]="xField.dirty || xField.touched ? (getError(xField.errors) | async) : ''"
                appSelectInputsByClick />
            </mat-form-field>
          </ng-template>
          <ng-template #yTemplate>
            <mat-form-field class="w-full dense-input no-subscript no-label" appearance="outline">
              <input
                type="number"
                required
                [range]="[0, getMaxOffsetByMainAxis]"
                number
                name="edge-hole-y"
                (click)="$any($event.target).select()"
                (ngModelChange)="checkErrors(yField.errors, 'y', i); valueUpdated()"
                matInput
                [(ngModel)]="item.y"
                #yField="ngModel"
                [matTooltipDisabled]="yField.valid"
                [matTooltip]="yField.dirty || yField.touched ? (getError(yField.errors) | async) : ''"
                appSelectInputsByClick />
            </mat-form-field>
          </ng-template>
        </td>
        <td>
          <csl-base-point-select
            [showAxis]="false"
            [disablePoints]="getDisabledPoints()"
            [value]="fastenerPoint2Position(item)"
            (valueChange)="setNewPosition($event, item)">
          </csl-base-point-select>
        </td>
        <td class="delete-col">
          <button mat-icon-button (click)="deleteCoord(item, i)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
